import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "crop-plan-home",
        path: "/crop-plan-home",
        component: () => import("./components/CropPlanContainer.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "campaign-select-nav-bar-item"] }
    },
    {
        name: "old-crop-plan-home",
        path: "/old-crop-plan-home",
        component: () => import("./components/OldCropPlanContainer.vue"),
        meta: { navbarItems: ["s-c-leader-select-nav-bar-item", 'farm-select-nav-bar-item', "campaign-select-nav-bar-item"] }
    },
    {
        name: "parcel-tenure",
        path: "/parcel-tenure",
        component: () => import("./components/ParcelTenureContainer.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}] }
    },
    {
        name: "crop-plan-home-plot-add",
        path: "/crop-plan-home-plot-add",
        component: () => import("./components/CropPlanContainerPlotAdd.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "campaign-select-nav-bar-item"] }
    },
    {
        name: "plot-qr-code-print",
        path: "/plot-qr-code-print",
        component: () => import("./components/tiles/qrCode/qrCodePrint.vue"),
        props: true
    },
];

export default routes;
